import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { RefrigeratorState } from './refrigerator.types';

import { ApplianceModel } from '~/core/models';

const initialState: RefrigeratorState = {
  selectedRefrigerator: undefined,
  inStoreRefrigeratorsUrl: undefined,
};

const refrigeratorSlice = createSlice({
  name: 'refrigerator',
  initialState,
  reducers: {
    updateSelectedRefrigerator: (
      state,
      action: PayloadAction<ApplianceModel | undefined>
    ) => {
      state.selectedRefrigerator = action.payload;
    },
    updateInStoreRefrigeratorsUrl: (state, action: PayloadAction<string>) => {
      state.inStoreRefrigeratorsUrl = action.payload;
    },
  },
});

export const { updateSelectedRefrigerator, updateInStoreRefrigeratorsUrl } =
  refrigeratorSlice.actions;

export default refrigeratorSlice.reducer;
